export default "__VITE_ASSET__lifl3Qo3__";